import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
export default {
  name: 'ViewBackgroundJobsBackgroundJobList',
  data() {
    return {
      tab: null,
      selectedAccounts: [],
      isOpen: false,
      itemInfo: {},
      favouriteFilter: false,
      accountFilterReady: false,
      itemsTotalCount: null,
      selectedTotal: []
    };
  },
  computed: {
    ...mapState('app', ['color', 'permissions']),
    canReadExports() {
      return this.permissions['IotHub.read'] || this.permissions['IotHub.manage'];
    },
    buttonsList() {
      return null;
    },
    allowedTabs() {
      const allTabs = [{
        key: 'file-export',
        hasPermission: this.permissions['IotHub.read'],
        translationKey: 'BackgroundJobs.BackgroundJobs.tabFileExportTitle'
      }, {
        key: 'csv-bulk-export',
        hasPermission: this.permissions['DigitalTwin.read'] || this.permissions['VirtualDevice.read'],
        translationKey: 'BackgroundJobs.BackgroundJobs.tabBulkExportTitle'
      }, {
        key: 'bg-jobs-edit',
        hasPermission: this.permissions['VirtualDevice.read'],
        translationKey: 'BackgroundJobs.BackgroundJobs.tabBgJobsTitle'
      }, {
        key: 'bg-jobs-import',
        hasPermission: this.permissions['VirtualDevice.read'],
        translationKey: 'BackgroundJobs.BackgroundJobs.tabBgJobsImportTitle'
      }, {
        key: 'bg-jobs-dtwin-duplicate',
        hasPermission: this.permissions['DigitalTwin.manage'],
        translationKey: 'BackgroundJobs.BackgroundJobs.tabBgJobsDtwinDuplicateTitle'
      }];
      return allTabs.filter(td => td.hasPermission);
    },
    searchTypes() {
      return [{
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.title'),
        param: 'title'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.group'),
        param: 'group',
        items: []
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.tag'),
        param: 'tag',
        items: []
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.keyValue'),
        param: 'keyValue'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props')['bridge.type'],
        param: 'bridge.type',
        items: []
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.deviceType'),
        param: 'deviceType',
        items: []
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.deviceId'),
        param: 'deviceId'
      }, {
        text: this.$i18n_t('Common.id'),
        param: 'id'
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.operationalStatus'),
        param: 'operationalStatus',
        items: [],
        combobox: true
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.health'),
        param: 'health',
        items: []
      }, {
        text: this.$i18n_t('DigitalTwin.VirtualDevice.props.zone'),
        param: 'zone',
        items: []
      }];
    },
    jobType() {
      switch (this.tab) {
        case 'bg-jobs-edit':
          return 'virtualDevicesEdit';
        case 'bg-jobs-import':
          return 'virtualDevicesCsvImport';
        case 'csv-bulk-export':
          return 'deviceStatesCsvExport';
        case 'bg-jobs-dtwin-duplicate':
          return 'digitalTwinBulkDuplicate';
        case 'file-export':
          return null;
        default:
          throw new Error(`Not supported tab key: ${this.tab}`);
      }
    }
  },
  watch: {
    '$route.query.tab': {
      handler() {
        this.getTabType();
      }
    }
  },
  async mounted() {
    this.getTabType();
    if (!this.$route.query.openRunnerId || isNaN(this.$route.query.openRunnerId)) {
      return;
    }
    const runner = await ApiService.fetchBackgroundRunner(this.$route.query.openRunnerId);
    this.showInfo(runner);
  },
  methods: {
    getTabType() {
      this.tab = this.$route.query.tab;
    },
    showInfo(item) {
      this.itemInfo = item;
      this.isOpen = true;
    },
    getItemsResults(items) {
      this.itemsTotalCount = items.totalCount;
      this.selectedTotal = items.data;
    },
    closeDialog() {
      this.isOpen = false;
      this.$refs.list.fetchList();
    }
  }
};